// ** React Imports
import { useEffect } from 'react'
import { UncontrolledDropdown, DropdownToggle } from 'reactstrap'
import { LogOut } from 'react-feather'
import { useIntl } from 'react-intl'
import { useState } from 'react'

const LinkToApp = () => {
    const intl = useIntl()
    const urlParams = new URLSearchParams(window.location.search)
    const [redirectUri, setRedirectUri] = useState(sessionStorage.getItem('redirect_uri'))
    const [appName, setAppName] = useState(sessionStorage.getItem('app_name'))

    useEffect(() => {
        if (window.location.search) {
            sessionStorage.setItem("redirect_uri", urlParams.get('redirect_uri'))
            sessionStorage.setItem("app_name", urlParams.get('app_name'))
            setRedirectUri(urlParams.get('redirect_uri'))
            setAppName(urlParams.get('app_name'))
        }
    }, [])

    const redirectHost = () => {
        sessionStorage.removeItem("redirect_uri")
        sessionStorage.removeItem("app_name")
        sessionStorage.removeItem("logo_url")
        window.location.replace(redirectUri)
    }

    return (
        <UncontrolledDropdown href='/' tag='li' className='dropdown-language nav-item'>
            {redirectUri && appName && redirectUri?.startsWith("http") && (
                <DropdownToggle tag='a' className='nav-link' onClick={() => redirectHost()}>
                    <LogOut size={16} className='mr-75' />
                    <span className='selected-language'>{intl.formatMessage({ id: "redirect" })}</span>
                </DropdownToggle>
            )}
        </UncontrolledDropdown>
    )
}

export default LinkToApp
